import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider, QueryCache } from 'react-query';
import { ThemeProvider, StylesProvider, jssPreset } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import * as Jss from 'jss';
import jssRtl from 'jss-rtl';

// Import styles
import theme from './theme';

// Import components
import { Routes } from './components/routes';
import SessionTimeout from './components/elements/organisms/SessionTimeout';

// Import react redux
import { Provider } from 'react-redux';

// Import store
import store from './store/store';
import { getConfiguration } from 'store/actions';

// Import translations
import './i18n';

// Import utilities
import { EN, DIRECTIONS } from 'helpers/variables';
import { useTranslations } from 'components/utilities';

const queryCache = new QueryCache();

const overrides = {
	queryCache,
	defaultOptions: {
		queries: {
			retry: 0,
			refetchOnWindowFocus: false
		}
	}
};

const queryClient = new QueryClient(overrides);

const jss = Jss.create({ plugins: [...jssPreset().plugins, jssRtl()] });

function App() {
	const { i18n } = useTranslations();

	const directions = i18n.language === EN ? DIRECTIONS.LTR : DIRECTIONS.RTL;
	const direction = directions.toLowerCase();

	React.useEffect(() => {
		document.body.style.direction = direction;
	}, [direction]);

	React.useEffect(() => {
		getConfiguration()(store.dispatch);
	}, []);

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<Provider store={store}>
				<QueryClientProvider client={queryClient}>
					<StylesProvider jss={jss}>
						<ThemeProvider theme={{ ...theme, direction }}>
							<CssBaseline />
							<BrowserRouter>
								<SessionTimeout />
								<Routes />
							</BrowserRouter>
						</ThemeProvider>
					</StylesProvider>
				</QueryClientProvider>
			</Provider>
		</MuiPickersUtilsProvider>
	);
}
export default App;
